export const DateFormate = (dates) => {
    if (!dates) {
        return null
    }
    const date = new Date(dates)
    let year, month, day, hour, min
    year = date.getFullYear()
    month =
    date.getMonth() <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()
    hour = date.getHours()
    min = date.getMinutes() < 10 ? "0"+date.getMinutes() : date.getMinutes()

    return `${day}/${month}/${year} at ${hour}:${min}`
}
// Only Date Formate YYYY-MM-DD
export const onlyDateFormate = (data) => {
    if (!data) {
        return null
    }
    const date = new Date(data)
    let singleDigitMonth = 9 // Months till september [January being 0]
    let year = date.getFullYear()
    let month =
    (date.getMonth() + 1) <= singleDigitMonth ? `0${date.getMonth() + 1}` : date.getMonth() + 1

    let day = date.getDate() <= singleDigitMonth ? `0${date.getDate()}` : date.getDate()

    return `${year}-${month}-${day}`
}

export const propsToFormDate=(date)=>{
    let year, month, day, hour, min
    if (!date) {
        return null
    }
    const newDate = new Date(date)
    let singleDigitMonth = 9 // Months till september [January being 0]
    year = newDate.getFullYear()
    month =
    (newDate.getMonth() + 1) <= singleDigitMonth ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1

    day = newDate.getDate() <= singleDigitMonth ? `0${newDate.getDate()}` : newDate.getDate()
    hour = date.getHours()
    min = date.getMinutes()
    return {
        day : day,
        month:month,
        year:year,
        hour:hour,
        min:min
    }
}

export const onlyMonthFormate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const localDate = `${year}-${month}`
    return localDate
}
